export default {
  inputNumber(str, precision = 2) {
    if (typeof str === "number") {
      str += "";
    }
    let len1 = str.substr(0, 1);
    let len2 = str.substr(1, 1);
    //如果第一位是0，第二位不是点，就用数字把点替换掉
    if (str.length > 1 && len1 === 0 && len2 !== ".") {
      str = str.substr(1, 1);
    }
    //第一位不能是.
    if (len1 === ".") {
      str = "";
    }
    //限制只能输入一个小数点
    if (str.indexOf(".") !== -1) {
      let str_ = str.substr(str.indexOf(".") + 1);
      if (str_.indexOf(".") !== -1) {
        str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
      }
    }
    //正则替换
    str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点

    // 小数点后只能输两位
    // str = str.replace(/\.\d\d\d$/, "");
    if (str.indexOf(".") > -1 && !/\.\d{1,2}$/.test(str)) {
      str = str.substr(0, str.indexOf(".") + (precision ? 1 + precision : 0));
    }
    return str;
  },
  randomString(len = 10, an) {
    an = an && an.toLowerCase();
    var str = "",
      i = 0,
      min = an == "a" ? 10 : 0,
      max = an == "n" ? 10 : 62;
    for (; i++ < len; ) {
      var r = (Math.random() * (max - min) + min) << 0;
      str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
    }
    return str;
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js